<template>
    <div>
        <h3>{{role.label}}</h3>
        <template v-for="(item, index) in permissions">
            <b-card :title="index" :key="index" class="innerCard">
                <div class="row">
                    <div class="col-sm-3 mb-1" v-for="(data) in item" :key="data.id">
                        <p class="mb-0">{{data.name }}</p>
                        <b-form-checkbox label="label" :value="data.id"  v-model="state" size="lg" :checked="data.assigned"  switch>
                        </b-form-checkbox>
                    </div>
                </div>
            </b-card>
        </template>
        <div class="row mt-3 justify-content-center" v-if="$can('save-permissions')">
            <b-button size="md"  class="btn btn-success  form-input" v-if="status"  @click="updatePermission(role.id)"> Save </b-button>
        </div>
    </div>
</template>

<script>
import {getPermissions} from "@/helpers/Helpers";

    export default {
        async created() {
            this.$store.commit('set', ['showLoader', true]);
            let res = await this.$store.dispatch('getrolepermissions', {id:this.$route.params.id, role_id:this.userRole.id});
            console.log(res);
            this.permissions = res.data;
            this.status = true;
            this.$store.commit('set', ['showLoader', false]);
            this.role = res.role;
            for (let data in this.permissions){
                for (let item in this.permissions[data]){
                    if (this.permissions[data][item].assigned ==true){
                         this.state.push(this.permissions[data][item].id);
                    }
                }
            }
            },
        data(){
            return{
                status:false,
                role:{},
                state:[],
                permissions:[],
                mode: { shape:'pill' , size :'lg', "variant": "3d" },
                color: 'primary'
            }
        },
      computed: {
        userRole: function() {
          return this.$store.getters.userRole;
        }
      },
        methods:{
             async updatePermission(id){
                try {
                    this.$store.dispatch('updatePermissions', {
                        id: id,
                        permissions:this.state,
                        ispermission:true
                    }).then(async (res) => {
                        if (res.status == 201){
                          await getPermissions()
                          this.$store.dispatch("getnavigation");
                          this.showToast(res.data.message, "SUCCESS");
                          setTimeout(() => this.$router.push('/roles'), 1000);
                        }
                    });
                }catch (e) {
                    this.showError(e);
                }
            }
        }

    }
</script>

<style scoped>
.innerCard{
    background-color: #eaeef1;
}
</style>